module.exports = __webpack_public_path__ + "static/media/first-lithonia-medical-center-national-heart-month.73f2b8ac.jpg";